module.exports = __webpack_public_path__ + "static/media/4.e8108aa7.svg";